import { BeatResolution } from '@arpeggi/shared'
import { Instance, types } from 'mobx-state-tree'
import { ForDirectExtend } from '../../../../features/mobx'

const _LoopSettingsStore = types
  .model({
    resolution: BeatResolution.EIGHTH_NOTE
  })
  .actions((self) => {
    function updateResolution(resolution: BeatResolution) {
      self.resolution = resolution
    }
    return { updateResolution }
  })

interface LoopSettingsStoreType extends ForDirectExtend<typeof _LoopSettingsStore> {}
export const LoopSettingsStore: LoopSettingsStoreType = _LoopSettingsStore

export interface ILoopSettingsStore extends ForDirectExtend<Instance<typeof LoopSettingsStore>> {}
